module.exports = __webpack_public_path__ + "img/icon-pdf.51b6e3ff.svg";